import type {
  WordleGameState,
  CharacterState,
  WordleRow,
} from "@kekkle/shared/types/fields/wordle-game-state/wordle-game-state";

export function checkRow(
  gameState: WordleGameState,
  correctWord: string,
  currentRow: number,
): WordleGameState {
  if (currentRow === -1) {
    return gameState;
  }
  const row = gameState[currentRow]!;
  if (!row.every((cell) => cell.character !== "")) {
    return gameState;
  }

  const correctWordCounts: Record<string, number> = {};
  for (let i = 0; i < correctWord.length; i++) {
    const char = correctWord[i]!;
    correctWordCounts[char] = (correctWordCounts[char] || 0) + 1;
  }

  const markedCounts: Record<string, number> = {};

  for (let i = 0; i < row.length; i++) {
    const cell = row[i]!;
    if (cell.character === correctWord[i]) {
      markedCounts[cell.character] = (markedCounts[cell.character] || 0) + 1;
      cell.isCorrect = true;
      cell.isLocked = true;
    } else {
      cell.isLocked = true;
    }
  }

  for (let i = 0; i < row.length; i++) {
    const cell = row[i]!;
    if (!cell.isCorrect && correctWord.includes(cell.character)) {
      markedCounts[cell.character] = (markedCounts[cell.character] || 0) + 1;
      if (markedCounts[cell.character]! <= correctWordCounts[cell.character]!) {
        cell.isPresent = true;
      }
    }
  }

  return gameState;
}

export function addLetter(
  gameState: WordleGameState,
  currentRow: number,
  currentColumn: number,
  key: string,
): WordleGameState {
  if (gameState[currentRow]![currentColumn]!.character !== "") {
    return gameState;
  }
  gameState[currentRow]![currentColumn] = {
    character: key,
    isCorrect: false,
    isLocked: false,
  };
  return gameState;
}

export function removeLetter(
  gameState: WordleGameState,
  currentRow: number,
  currentColumn: number,
): WordleGameState {
  if (currentColumn >= 0) {
    if (gameState[currentRow]![currentColumn]!.character === "") {
      if (currentColumn > 0) {
        currentColumn--;
      }
    }
    gameState[currentRow]![currentColumn] = {
      character: "",
      isCorrect: false,
      isPresent: false,
      isLocked: false,
    };
  }
  return gameState;
}

export function resetWordle(): WordleGameState {
  return Array.from<WordleRow, WordleRow>({ length: 6 }, () =>
    Array.from<CharacterState, CharacterState>({ length: 6 }, () => ({
      character: "",
      isCorrect: false,
      isPresent: false,
      isLocked: false,
    })),
  );
}
